import type { ReactNode } from "react";
import { CardContent } from "@/components/ui";
import { ModifiedSectionCard } from "./ModifiedSectionCard";

export interface EntityHeaderLayoutProps {
  modified?: boolean;
  className?: string;
  icon: ReactNode;
  aside?: ReactNode;
  children: ReactNode;
}

export function EntityHeaderLayout({
  modified = false,
  className,
  icon,
  aside,
  children,
}: EntityHeaderLayoutProps) {
  return (
    <ModifiedSectionCard modified={modified} className={className}>
      <CardContent className="pt-6">
        <div
          className={
            aside
              ? "flex flex-col gap-6 sm:flex-row sm:items-start sm:justify-between"
              : undefined
          }
        >
          <div className="flex min-w-0 flex-1 items-start gap-4">
            <div className="shrink-0">{icon}</div>
            <div className="min-w-0 flex-1">{children}</div>
          </div>
          {aside ? (
            <div className="shrink-0 border-t border-surface-100 pt-6 sm:max-w-xs sm:border-t-0 sm:border-l sm:pt-0 sm:pl-6">
              {aside}
            </div>
          ) : null}
        </div>
      </CardContent>
    </ModifiedSectionCard>
  );
}
